import { Button } from '@strata/react-buttons';
import { ReasonInput } from '@strata/react-compound-inputs';
import { TextInputFormik } from '@strata/react-inputs';
import { AddressDetailLabelValue, DetailLabelValuePair } from '@strata/react-label-value-pairs';
import { SuccessToast } from '@strata/react-toast-message';
import { validationStrings } from '@strata/strata-ui-strings';
import classNames from 'classnames';
import { useFormikContext } from 'formik';
import * as Yup from 'yup';

import { updatePrescriber } from 'api/treatmentAPI';
import { handleError } from 'services/Error';
import { useLazyGetPrescriberDetailsQuery } from 'store/api/referenceApi';

export const UpdateActiveReferralDataPrescriber = () => {
    const { values, setFieldValue, errors } = useFormikContext();
    const { prescriberNpi, prescriberData } = values;
    const [getPrescriberDetails] = useLazyGetPrescriberDetailsQuery();

    const handleButtonClick = async () => {
        if (!prescriberNpi) {
            return;
        }

        try {
            const prescriberDetails = await getPrescriberDetails({ prescriberNpi }).unwrap();
            await setFieldValue('prescriberData', prescriberDetails);
            SuccessToast({
                message: `Prescriber ${prescriberNpi} is valid.`,
            });
        } catch (err) {
            handleError(`Error: Prescriber ${prescriberNpi} not found.`, err);
        }
    };

    return (
        <>
            <TextInputFormik
                id="prescriberNpi"
                label="Prescriber NPI"
                onChange={async (e) => {
                    await setFieldValue('prescriberNpi', e.target.value);
                    await setFieldValue('prescriberData', null);
                }}
                required
            />
            <Button
                intent={Button.Intent.PRIMARY}
                label="Lookup Npi"
                onClick={handleButtonClick}
                disabled={errors.prescriberNpi}
            />
            {prescriberData && (
                <>
                    <div
                        className={classNames(
                            'flex__gap--medium',
                            'margin__top--medium',
                            'margin__bottom--medium',
                        )}
                    >
                        <DetailLabelValuePair
                            label="Prescriber Name"
                            value={prescriberData.prescriberName}
                        />
                        <AddressDetailLabelValue
                            label="Address"
                            address1={prescriberData.address1}
                            address2={prescriberData.address2}
                            city={prescriberData.city}
                            state={prescriberData.state}
                            zip={prescriberData.zip}
                        />
                    </div>
                    <ReasonInput
                        className="margin__top--medium"
                        reasons={['Prescriber Incorrect']}
                    />
                </>
            )}
        </>
    );
};

UpdateActiveReferralDataPrescriber.initialValues = () => ({});

UpdateActiveReferralDataPrescriber.validationSchema = {
    prescriberNpi: Yup.string()
        .length(10, validationStrings.exactCharacter.lambda(10))
        .required(validationStrings.requiredField.errorMessage),
    prescriberData: Yup.object({
        npi: Yup.string(),
    }).required(validationStrings.requiredField.errorMessage),
    ...ReasonInput.validationSchema,
};

UpdateActiveReferralDataPrescriber.onSubmit = async ({ treatmentDetails, values }) => {
    const { prescriberNpi } = values ?? {};
    const { payerId, treatmentId } = treatmentDetails ?? {};
    // Update prescriber on treatment
    await updatePrescriber({
        payerId,
        treatmentId,
        prescriberNpi,
        ...ReasonInput.submitValues(values),
    });
};
